/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Suprême NTM.
 *
 * Suprême NTM can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file BackgroundImage.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */
import glsl from 'glslify'
import backgroundImageFs from '../glsl/backgroundImageF.glsl'
import backgroundImageVs from '../glsl/backgroundImageV.glsl'
import * as THREE from 'three'

export default class BackgroundImage {
    constructor () {
        this.uniforms = {
            resolution: {
                type: 'v2',
                value: new THREE.Vector2(document.body.clientWidth, window.innerHeight)
            },
            imageResolution: {
                type: 'v2',
                value: new THREE.Vector2(2048, 1356)
            },
            texture: {
                type: 't',
                value: null
            }
        }

        this.loader = new THREE.TextureLoader()
        this.isInit = false
        this.imageUrl = null
        this.tex = null
        this.obj = null
    }

    init (callback) {
        if (this.isInit) return
        this.isInit = true

        this.uniforms.texture.value = null
        this.obj = this.createObj()

        callback()
    }

    loadImage (imageUrl) {
        return new Promise(resolve => {
            this.imageUrl = imageUrl
            this.loader.load(this.imageUrl, (tex) => {
                this.tex = tex
                resolve()
            })
        })
    }

    switchImage () {
        this.uniforms.texture.value = this.tex
    }

    createObj () {
        return new THREE.Mesh(
            new THREE.PlaneBufferGeometry(2, 2),
            new THREE.RawShaderMaterial({
                uniforms: this.uniforms,
                vertexShader: glsl(backgroundImageVs),
                fragmentShader: glsl(backgroundImageFs)
            })
        )
    }

    resize () {
        this.uniforms.resolution.value.set(document.body.clientWidth, window.innerHeight)
    }
}



// WEBPACK FOOTER //
// ./webpack/js/scene/glitch/BackgroundImage.js